import React, { FC, ReactElement } from 'react';
import * as S from './Dialog.style';
import close from 'assets/close.svg';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  submitButton?: ReactElement;
  bgWrapper?: string;
  title?: string;
  style?: React.CSSProperties;
}

export const Dialog: FC<IProps> = ({
  isOpen,
  onClose,
  children,
  submitButton,
  bgWrapper = 'white',
  title,
  style
}) => {
  return (
    <S.DialogOverlay open={isOpen}>
      <dialog open={isOpen} style={style}>
        <div style={{ marginBottom: 16, fontSize: 24, fontWeight: 700 }}>
          {title}
        </div>
        <S.Container>{children}</S.Container>
        <S.CloseWrapper onClick={onClose}>
          <img src={close} alt="close" />
        </S.CloseWrapper>
        {submitButton && (
          <S.ButtonWrapper bgWrapper={bgWrapper}>{submitButton}</S.ButtonWrapper>
        )}
      </dialog>
    </S.DialogOverlay>
  );
};
